import React from "react";

function SovereignSaddles() {
  return (
    <div className="w-full mx-auto space-y-5">
      {/* Brand Intro */}
      <div className="bg-gray-50 p-6 rounded-xl shadow-sm">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Sovereign Saddles
        </h1>
        <p className="text-gray-700 leading-relaxed text-base">
          <strong>Sovereign Saddles India</strong>, a division of Sovereign
          Industries, is a premier bicycle saddle manufacturer known for its
          exceptional craftsmanship. They produce high-quality, ergonomic
          saddles that focus on comfort and performance. With a long-standing
          history in the industry, Sovereign Saddles has become a trusted choice
          for cycling enthusiasts both locally and globally, thanks to their
          commitment to innovation and customer satisfaction. They provide
          saddles for many leading bicycle brands in India and around the world,
          catering to diverse cycling needs.
        </p>
      </div>

      {/* Key Highlights */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900 mb-1">
          Key Highlights
        </h2>
        <ul className="list-disc pl-6 text-gray-700 text-sm space-y-2">
          <li>
            <strong className="text-gray-900">Leading Manufacturer:</strong>{" "}
            Part of Sovereign Industries, a top bicycle saddle manufacturer in
            India.
          </li>
          <li>
            <strong className="text-gray-900">Exceptional Craftsmanship:</strong>{" "}
            Known for high-quality, ergonomic designs focusing on comfort and
            performance.
          </li>
          <li>
            <strong className="text-gray-900">Long-Standing History:</strong>{" "}
            Pioneers in producing budget-friendly, high-quality saddles.
          </li>
          <li>
            <strong className="text-gray-900">
              Innovation & Customer Satisfaction:
            </strong>{" "}
            Strong commitment to continuous improvement and customer-centric
            design.
          </li>
          <li>
            <strong className="text-gray-900">
              Advanced Materials & Technologies:
            </strong>{" "}
            Uses cutting-edge materials and technologies.
          </li>
          <li>
            <strong className="text-gray-900">Diverse Product Range:</strong>{" "}
            Saddles for casual riding to competitive sports.
          </li>
          <li>
            <strong className="text-gray-900">Trusted by Leading Brands:</strong>{" "}
            Supplies many top bicycle brands in India and globally.
          </li>
          <li>
            <strong className="text-gray-900">Global Presence:</strong>{" "}
            Significant market presence and loyal customer base worldwide.
          </li>
        </ul>
      </div>
    </div>
  );
}

export default SovereignSaddles;
